import { render, staticRenderFns } from "./LaboratorioEditar.vue?vue&type=template&id=135de35d"
import script from "./LaboratorioEditar.vue?vue&type=script&lang=js"
export * from "./LaboratorioEditar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports